import ArrowIcon from "@/components/icons/ArrowIcon";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { useTranslation } from "next-i18next";

const servicesPages = [
  {
    id: 1,
    name: "Maintenance",
    url_key: "/maintenance",
  },
  // {
  //   id: 2,
  //   name: "One to one guidance",
  //   url_key: "/guidance",
  // },
];

const ServiceDropdown = () => {
  const { t } = useTranslation("common");
  const { locale } = useRouter();
  const [open, setOpen] = useState(false);

  return (
    false && (
      <div className="relative">
        <button
          className={`flex items-center gap-1.5 px-2 ${
            locale === "en" ? "border-r" : "border-l"
          } border-white`}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span>{locale === "en" ? "Services" : "الخدمات"}</span>{" "}
          <ArrowIcon
            className={`size-2 ${
              open ? "rotate-[-90deg]" : "rotate-90"
            } transition-all`}
          />
        </button>

        {open && (
          <ul
            className={`absolute top-8 z-[100] flex w-64 flex-col gap-2 rounded-b-md  border bg-white p-2 shadow-categories ${
              locale === "en" ? "right-0" : "left-0"
            }}`}
          >
            {servicesPages?.map((page, i) => {
              return (
                <li
                  key={i}
                  className="group border border-transparent text-sm font-medium hover:rounded-md text-black hover:bg-tertiary-900 hover:text-white"
                >
                  <Link
                    className="flex items-center justify-between px-4 py-2"
                    href={page.url_key}
                    onClick={() => setOpen(false)}
                  >
                    <span>{t(page?.name)}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    )
  );
};

export default ServiceDropdown;
